var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHappiness(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#happiness_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.629 12c0 5.87-4.759 10.629-10.629 10.629C6.13 22.629 1.371 17.87 1.371 12 1.371 6.13 6.13 1.371 12 1.371c5.87 0 10.629 4.759 10.629 10.629zM24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12zm-5.743.918c.468.074.792.515.664.97a7.273 7.273 0 01-11.787 3.51 7.266 7.266 0 01-2.245-3.609c-.122-.457.208-.893.677-.96l.103-.015c.469-.068.897.261 1.036.714a5.453 5.453 0 005.175 3.846 5.447 5.447 0 003.568-1.296 5.444 5.444 0 001.66-2.477c.146-.45.578-.773 1.046-.7l.103.017zM9.771 8.914a1.543 1.543 0 11-3.085 0 1.543 1.543 0 013.085 0zm6 1.543a1.542 1.542 0 10.001-3.086 1.543 1.543 0 100 3.086z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "happiness_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgHappiness;